import * as React from "react"
const SvgMenuVertical = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 20.126q-.619 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06a1.45 1.45 0 0 1 1.06-.44q.619 0 1.06.44.44.442.44 1.06 0 .62-.44 1.06-.441.44-1.06.44m0-5.769a1.45 1.45 0 0 1-1.06-.44 1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06a1.45 1.45 0 0 1 1.06-.44q.619 0 1.06.44.44.442.44 1.06 0 .62-.44 1.06a1.45 1.45 0 0 1-1.06.44m0-5.77q-.619 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.058A1.45 1.45 0 0 1 12 5.588q.619 0 1.06.44.44.44.44 1.06 0 .618-.44 1.06a1.45 1.45 0 0 1-1.06.44Z" />
  </svg>
)
export default SvgMenuVertical
